export const reduxKey = '@@DUPERBROWSE';
export const actionKey = '@@DUPERBROWSE';
export const initialState = {
    streamStack: [],
    isSessionActive: false,
    isHistoryManagementEnabled: true
};
export const FEEDBACK_PAGE_DUPERBROWSE_STREAMID = `${reduxKey}:FB:STREAM`;
export const FEEDBACK_PAGE_DUPERBROWSE_ITEMID = `${reduxKey}:FB:ITEM`;
